module.exports = __webpack_public_path__ + "static/media/solar21_black_small.ce373e17.svg";